import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-driver-info',
    templateUrl: './driver-info.component.html',
    styleUrls: ['./driver-info.component.css'],
    standalone: false
})
export class DriverInfoComponent {
  @Input() showDeviceInfo: boolean = false;

}
